<panel style="min-width: 650px">
	<h1>{{ 'order-onboarding-list.title' | translate }}</h1>
	<blocklist blockListType="orderOnboarding"
			   [items]="orderOnboardingTaskflows"
			   (onSelect)="selectOnboardingflow($event)">
	</blocklist>
</panel>
